export default {
  name: "StatusBar"
};